export enum SampleType {
    OneShot = 'one_shot',
    Loop = 'loop',
}
